import { Plural, Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';

import { StepMessage } from '../../shared/StepMessage';

const Repair = ({ request }: { request: RequestWithRelations }) => {
  const activeArticlesInRepair = request.articles.filter(
    (article) => article.step?.step === 'repair' && !article.cancelledAt
  );

  const message = request.client ? (
    <Trans id="store.request.repair.text.client">
      Our experts are currently working on the{' '}
      <Plural value={activeArticlesInRepair.length} one="item" other="items" />. The client will be
      notified when it is finished.
    </Trans>
  ) : (
    <Trans id="store.request.repair.text">
      Our experts are currently working on the{' '}
      <Plural value={activeArticlesInRepair.length} one="item" other="items" />. You will be
      notified when it is finished.
    </Trans>
  );

  return (
    <BrandRequestMainContent>
      <Stack gap="1.5rem">
        <ClientStepper request={request} />

        <StepMessage message={message} />

        <ClientArticlesList request={request} showPrice={!!request.client} showArticleComment />
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Repair;
